var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg73StepType1Selected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.6,
    y: 3.6,
    width: 8.8,
    height: 8.8,
    rx: 2.5,
    ry: 2.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 8,
    ry: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.98,8.51h-.73l.38,.96c.03,.07,0,.14-.06,.17l-.34,.15c-.06,.03-.13,0-.16-.07l-.36-.91-.6,.63c-.08,.08-.21,.02-.21-.09v-3.02c0-.12,.14-.17,.21-.09l1.96,2.06c.08,.08,.02,.22-.09,.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.1,2.66c-1.9,0-3.44,1.54-3.44,3.44h1.88c0-.86,.7-1.56,1.56-1.56v-1.88Zm3.8,1.88c.86,0,1.56,.7,1.56,1.56h1.88c0-1.9-1.54-3.44-3.44-3.44v1.88Zm1.56,5.36c0,.86-.7,1.56-1.56,1.56v1.88c1.9,0,3.44-1.54,3.44-3.44h-1.88Zm-5.36,1.56c-.86,0-1.56-.7-1.56-1.56h-1.88c0,1.9,1.54,3.44,3.44,3.44v-1.88Zm-1.56-1.56v-3.8h-1.88v3.8h1.88Zm5.36,1.56h-3.8v1.88h3.8v-1.88Zm1.56-5.36v3.8h1.88v-3.8h-1.88Zm-5.36-1.56h3.8v-1.88h-3.8v1.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg73StepType1Selected);
export default __webpack_public_path__ + "static/media/73-step-type1-selected.a793994c45a2b4a4be83da4c73802e26.svg";
export { ForwardRef as ReactComponent };